import React, { PureComponent } from 'react';
import Text from "../../../components/Text";
import Grid from "@mui/material/Grid";
import BlockContent from '../../../components/BlockContent';
import HeaderDiv from '../../../components/HeaderDiv';
import { colors } from "../../../theme";
import BubbleSelectBlock from "../../../components/BubbleSelectBlock";
import NumberInput from "../../../components/TextFields/NumberInput";
class ProductRatesBlock extends PureComponent {
  _saveChildField = (type, id, field, value) => {
    const specialityProductID = this.props.productRates.specialityProductID;
    const data = {
      ...this.props.productRates[type],
      [id]: {
        ...this.props.productRates[type][id],
        [field]: value
      }
    };
    this.props.saveValueInState(specialityProductID, type, data);
  };
  _getGrossRate = (netRate, commissionPercentage, markup) => {
    return netRate / (1 - markup / 100) / (1 - commissionPercentage / 100);
  };
  _getTotalVolumeBasedPremium = (volume, rate, commissionPercentage, markup) => {
    const grossRate = rate / (1 - markup / 100) / (1 - commissionPercentage / 100);
    return volume * grossRate;
  };
  _censusRatesBlock = () => {
    const classIDs = Object.keys(this.props.productRates.classes);
    return /*#__PURE__*/React.createElement("div", null, classIDs.map(classID => {
      const classData = this.props.productRates.classes[classID];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderDiv, {
        style: {
          borderBottom: "1.5px solid #F1F1F1",
          marginTop: 20,
          marginBottom: 20
        }
      }), /*#__PURE__*/React.createElement(Text, {
        extraLarge: true,
        color: this.props.whitelabel.primaryColor,
        margin: "10px 0"
      }, `Class ${classData.title}`), /*#__PURE__*/React.createElement(Text, null, "How often would you like this class to be invoiced for this product?"), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
        first: {
          title: "Monthly",
          selected: classData.paymentInterval === 'monthly',
          field: 'paymentIntervalMonthly'
        },
        second: {
          title: "Yearly",
          selected: classData.paymentInterval === 'yearly',
          field: 'paymentIntervalYearly'
        },
        handleChange: field => {
          if (field === 'paymentIntervalMonthly') {
            this._saveChildField('classes', classID, 'paymentInterval', 'monthly');
          }
          if (field === 'paymentIntervalYearly') {
            this._saveChildField('classes', classID, 'paymentInterval', 'yearly');
          }
        }
      }), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Commission Percentage",
        fullWidth: true,
        suffix: "%",
        value: classData.commissionPercentage,
        onBlur: e => this._saveChildField('classes', classID, 'commissionPercentage', e.target.value),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Markup",
        fullWidth: true,
        suffix: "%",
        value: classData.markup,
        variant: "outlined",
        disabled: true
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Solo Net Rate",
        fullWidth: true,
        prefix: "$ ",
        value: classData.rates.solo,
        onBlur: e => this._saveChildField('classes', classID, 'rates', {
          ...classData.rates,
          solo: e.target.value
        }),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Duo Net Rate",
        fullWidth: true,
        prefix: "$ ",
        value: classData.rates.duo,
        onBlur: e => this._saveChildField('classes', classID, 'rates', {
          ...classData.rates,
          duo: e.target.value
        }),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Family Net Rate",
        fullWidth: true,
        prefix: "$ ",
        value: classData.rates.family,
        onBlur: e => this._saveChildField('classes', classID, 'rates', {
          ...classData.rates,
          family: e.target.value
        }),
        variant: "outlined"
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Solo Gross Rate",
        fullWidth: true,
        prefix: "$ ",
        value: this._getGrossRate(classData.rates.solo, classData.commissionPercentage, classData.markup),
        variant: "outlined",
        disabled: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Duo Gross Rate",
        fullWidth: true,
        prefix: "$ ",
        value: this._getGrossRate(classData.rates.duo, classData.commissionPercentage, classData.markup),
        variant: "outlined",
        disabled: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Family Gross Rate",
        fullWidth: true,
        prefix: "$ ",
        value: this._getGrossRate(classData.rates.family, classData.commissionPercentage, classData.markup),
        variant: "outlined",
        disabled: true
      }))));
    }));
  };
  _volumeRatesBlock = () => {
    const divisionIDs = Object.keys(this.props.productRates.divisions);
    return /*#__PURE__*/React.createElement("div", null, divisionIDs.map(divisionID => {
      const divisionData = this.props.productRates.divisions[divisionID];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderDiv, {
        style: {
          borderBottom: "1.5px solid #F1F1F1",
          marginTop: 20,
          marginBottom: 20
        }
      }), /*#__PURE__*/React.createElement(Text, {
        extraLarge: true,
        color: this.props.whitelabel.primaryColor,
        margin: "20px 0"
      }, divisionData.title), /*#__PURE__*/React.createElement(Text, null, "How often would you like this division to be invoiced for this product?"), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
        first: {
          title: "Monthly",
          selected: divisionData.paymentInterval === 'monthly',
          field: 'paymentIntervalMonthly'
        },
        second: {
          title: "Yearly",
          selected: divisionData.paymentInterval === 'yearly',
          field: 'paymentIntervalYearly'
        },
        handleChange: field => {
          if (field === 'paymentIntervalMonthly') {
            this._saveChildField('divisions', divisionID, 'paymentInterval', 'monthly');
          }
          if (field === 'paymentIntervalYearly') {
            this._saveChildField('divisions', divisionID, 'paymentInterval', 'yearly');
          }
        }
      }), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Commission Percentage",
        fullWidth: true,
        suffix: "%",
        value: divisionData.commissionPercentage,
        onBlur: e => this._saveChildField('divisions', divisionID, 'commissionPercentage', e.target.value),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Markup",
        fullWidth: true,
        suffix: "%",
        value: divisionData.markup,
        variant: "outlined",
        disabled: true
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Volume",
        fullWidth: true,
        value: divisionData.volume,
        onBlur: e => this._saveChildField('divisions', divisionID, 'volume', e.target.value),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Net Rate",
        fullWidth: true,
        prefix: "$ ",
        value: divisionData.rate,
        onBlur: e => this._saveChildField('divisions', divisionID, 'rate', e.target.value),
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/React.createElement(NumberInput, {
        label: "Premium (Monthly)",
        fullWidth: true,
        prefix: "$ ",
        value: this._getTotalVolumeBasedPremium(divisionData.volume, divisionData.rate, divisionData.commissionPercentage, divisionData.markup),
        variant: "outlined",
        disabled: true
      }))));
    }));
  };
  render() {
    const {
      productRates,
      whitelabel,
      name,
      saveValueInState,
      language
    } = this.props;
    return /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: "1.5px solid #F1F1F1"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, `${name} (${this.props.carrier})`)), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Text, null, "Please select the type of invoicing for this product."), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: "Census",
        selected: productRates.invoicingType === 'census',
        field: 'invoicingTypeCensus'
      },
      second: {
        title: "Volume",
        selected: productRates.invoicingType === 'volume',
        field: 'invoicingTypeVolume'
      },
      handleChange: field => {
        if (field === 'invoicingTypeCensus') {
          saveValueInState(productRates.specialityProductID, 'invoicingType', 'census');
        }
        if (field === 'invoicingTypeVolume') {
          saveValueInState(productRates.specialityProductID, 'invoicingType', 'volume');
        }
      }
    }))), productRates.invoicingType === 'census' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      margin: "10px 0 20px 0"
    }, "Please set the invoicing interval and the required fields for each class listed below."), this._censusRatesBlock()), productRates.invoicingType === 'volume' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      margin: "10px 0 20px 0"
    }, "Please set the invoicing interval and the required fields for each division listed below."), this._volumeRatesBlock())));
  }
}
export default ProductRatesBlock;